import Header from "./header";

const Ecosystem = () => {
  return (
    <>
      <Header
        title="Galaxy<br/>Ecosystem"
        description="Browse and search projects built on the Galaxy protocol. Are you building something cool?"
        side="text-left"
        link="Apply for a grant."
      />
    </>
  );
};
export default Ecosystem;
